import { render, staticRenderFns } from "./TimetableView-Base.vue?vue&type=template&id=b4b812f4"
import script from "./TimetableView-Base.vue?vue&type=script&lang=js"
export * from "./TimetableView-Base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports